import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LZString from "lz-string";
import BaseCard from "./BaseCard";

const SharedCard = () => {
  const navigate = useNavigate();
  const [cardData, setCardData] = React.useState(null);
  const [name, setName] = React.useState("");

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const data = urlParams.get("data");
    if (data) {
      try {
        const decompressed = LZString.decompressFromEncodedURIComponent(data);
        const parsedData = JSON.parse(decompressed);
        setCardData(parsedData);
        setName(parsedData.name || "");
      } catch (error) {
        console.error("Error parsing card data:", error);
      }
    }
  }, []);

  if (!cardData) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#f8f6ed",
          p: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h5" color="text.secondary">
          Loading card...
        </Typography>
      </Box>
    );
  }

  return (
    <BaseCard
      cardData={cardData}
      name={name}
      showShareButtons={false}
      showSparkles={true}
      showMakeYourOwnButton={true}
      onMakeYourOwn={() => navigate("/memo-card")}
    />
  );
};

export default SharedCard;
